/**
 * formatDepartureTime — Pure function that formats a Leave_By_Time Date
 * into a clock string for the Time_to_Go_Panel.
 *
 * Output pattern: "h:mm AM/PM TZ" (e.g., "2:30 PM EST")
 * Returns null for null/invalid input; callers map null to the
 * "Departure time unavailable" message.
 *
 * Requirements: 1.2
 */

/**
 * Format a Leave_By_Time Date into a display string with hour, minute,
 * and timezone abbreviation.
 *
 * @param {Date|null|undefined} date - The Leave_By_Time to format
 * @returns {string|null} Formatted clock string or null if unavailable
 */
export function formatDepartureTime(date) {
  if (date == null) return null;
  if (!(date instanceof Date) || isNaN(date.getTime())) return null;

  return date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZoneName: 'short',
  });
}

export default formatDepartureTime;
